module.exports = __webpack_public_path__ + "static/img/3_2.61caa20.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/preview/department/3_2.png
// module id = L82C
// module chunks = 1